import { Sparkles, User, Wallet, Building2, Briefcase, ShieldCheck, Users, FileText } from 'lucide-react';

export const WELCOME_SLIDES = {
  creator: [
    {
      icon: Sparkles,
      title: 'Welcome to Mylikeness',
      body: "The safe way to license your likeness. You stay in control — every deal, every piece of AI content needs your approval.",
      accent: 'from-blue-500 to-indigo-500',
    },
    {
      icon: User,
      title: 'Get discovered',
      body: 'Complete your profile and upload reference assets to your Likeness Pack. Agencies use these to find you and generate content.',
      accent: 'from-indigo-500 to-purple-500',
    },
    {
      icon: Wallet,
      title: 'Approve, then get paid',
      body: 'Review proposals, approve the AI content you like, and funds release straight to you — held securely until you say yes.',
      accent: 'from-emerald-500 to-teal-500',
    },
  ],
  agency: [
    {
      icon: Building2,
      title: 'Welcome to Mylikeness',
      body: 'Source creator likeness with airtight, compliant licensing — built for AI-generated content at scale.',
      accent: 'from-blue-600 to-indigo-600',
    },
    {
      icon: Briefcase,
      title: 'Campaigns & proposals',
      body: 'Create a campaign, connect creators, and send structured proposals with rights, usage, and pricing baked in.',
      accent: 'from-indigo-500 to-violet-500',
    },
    {
      icon: ShieldCheck,
      title: 'Pay with confidence',
      body: 'Funds are held until the creator approves the content. No surprises, full audit trail, clean licenses every time.',
      accent: 'from-emerald-500 to-teal-500',
    },
  ],
};

export const TOUR_STEPS = {
  creator: [
    { target: '[data-testid="nav-dashboard"]', title: 'Your home base', body: 'A snapshot of proposals, engagements and earnings.', placement: 'right' },
    { target: '[data-testid="nav-proposals"]', title: 'Incoming proposals', body: 'Offers from agencies land here. Accept, counter, or decline.', placement: 'right' },
    { target: '[data-testid="nav-engagements"]', title: 'Active engagements', body: 'Deals you have accepted live here — review and approve content.', placement: 'right' },
    { target: '[data-testid="nav-likeness"]', title: 'Likeness Pack', body: 'Upload reference photos and clips agencies use to generate content.', placement: 'right' },
    { target: '[data-testid="nav-payouts"]', title: 'Payouts', body: 'Track earnings and connect your bank to get paid.', placement: 'right' },
    { target: '[data-testid="nav-profile"]', title: 'Your profile', body: 'Keep this sharp — it is what agencies see first.', placement: 'right' },
  ],
  agency: [
    { target: '[data-testid="nav-dashboard"]', title: 'Your home base', body: 'Campaign activity, creators, and spend at a glance.', placement: 'right' },
    { target: '[data-testid="nav-campaigns"]', title: 'Campaigns', body: 'Create campaigns and send proposals to creators from here.', placement: 'right' },
    { target: '[data-testid="nav-creators"]', title: 'Creators', body: 'Find and connect with creators for your campaigns.', placement: 'right' },
    { target: '[data-testid="nav-finance"]', title: 'Finance', body: 'Payments, invoices, commission, and billing.', placement: 'right' },
    { target: '[data-testid="nav-licenses"]', title: 'Licenses', body: 'Every signed license is stored and verifiable here.', placement: 'right' },
    { target: '[data-testid="nav-settings"]', title: 'Settings', body: 'Set governing law, branding, and your subscription.', placement: 'right' },
  ],
};
